import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { first } from 'rxjs/operators';

import { PointOfSaleFactory } from 'app/factories';
import { isUndefined, mergeRouteParams } from 'app/helpers';
import { PosRoleEnum } from 'app/interfaces';
import { PointOfSaleProfileState } from 'app/services';

export const posProfileRoleGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router: Router = inject(Router);
    const pointOfSaleFactory = inject(PointOfSaleFactory);
    const pointOfSaleProfileState = inject(PointOfSaleProfileState);
    const params = mergeRouteParams(route);
    if (!params.posId) {
        router.navigate(['/']);
        return false;
    }

    const canAccess: ReplaySubject<boolean> = new ReplaySubject(1);

    if (route.data && route.data['allowedRoles'] && route.data['allowedRoles'].indexOf(PosRoleEnum.Guest) === -1) {
        pointOfSaleFactory
            .getPointOfSaleRole(params.posId)
            .pipe(first())
            .subscribe({
                next: (meRole) => {
                    if (
                        route.data &&
                        route.data['allowedRoles'] &&
                        !isUndefined(meRole) &&
                        route.data['allowedRoles'].indexOf(meRole) !== -1
                    ) {
                        pointOfSaleProfileState.setIsAdminProfile(!!route.data['adminProfile']);
                        canAccess.next(true);
                        return;
                    }

                    router.navigate(['/pos', params.posId]);
                    canAccess.next(false);
                },
                error: () => {
                    router.navigate(['/']);
                    canAccess.next(false);
                },
            });
    } else {
        pointOfSaleProfileState.setIsAdminProfile(false);
        canAccess.next(true);
    }

    return canAccess;
};
